export default "__VITE_ASSET__BGr9Okpy__"